import { isfunc } from 'piral-base';
import { none } from './helpers';
export const defaultLayouts = ['desktop', 'tablet', 'mobile'];
export const defaultBreakpoints = ['(min-width: 991px)', '(min-width: 481px)', '(max-width: 480px)'];
const mm = typeof window === 'undefined' || !isfunc(window.matchMedia)
    ? () => ({ matches: none })
    : (q) => window.matchMedia(q);
export function getCurrentLayout(breakpoints, layouts, defaultLayout) {
    const query = breakpoints.findIndex((q) => mm(q).matches);
    const layout = layouts[query];
    return layout !== undefined ? layout : defaultLayout;
}
//# sourceMappingURL=media.js.map